import { Tag, TagProps } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import styled from "styled-components";

const TagStyled = styled(Tag)`
  text-transform: uppercase;
  & > span {
    min-width: auto;
  }
`;

type BetaTagProps = {
  size?: TagProps["size"];
};

export const BetaTag = ({ size = "xSmall" }: BetaTagProps) => {
  const { t } = useTranslation("common");
  return (
    <TagStyled size={size} variant="blue" mode="outline">
      {t("Beta")}
    </TagStyled>
  );
};
